import { DateTime } from 'luxon'
import { CustomParams, SlidingParams } from '../types/SpyLaunchSettings'

export function spyLaunchSettingsConvertToStateValue(spyLaunchSettings: any){
    if (spyLaunchSettings === undefined){
        return undefined
    }

    if (spyLaunchSettings.mode === 'sliding'){
        return {
            ...spyLaunchSettings
        }

    }

    if (spyLaunchSettings.mode === 'custom'){
        return {
            mode: 'custom',
            params: {
                periods: [
                    {
                        startDate: spyLaunchSettings.params.periods[0].startDate.toISO(),
                        endDate: spyLaunchSettings.params.periods[0].endDate.toISO()
                    }
                ]
            }
        } 
    }

}